<template>
  <div class="modal_dim on">
    <!--'on 추가'-->
    <div class="modal_wrap">
      <div class="modal_inner center w1200">
        <div class="modal w50p">
          <div class="modal_head">
            <h1 class="h1">
              <span>시험 안내</span>
            </h1>
          </div>
          <div class="modal_con">
            <div class="modal_txt">
              <div class="inform_box">
                <ol class="dot li_space">
                  <li class="small color">
                    <span class="ol_li_txt">
                      (사)한국외식산업협회 및 지정기관의 교육을 수료하신 분에
                      한하여, 신청이 가능합니다. 시험을 원하시는 분은 교육을
                      수료하신 후 신청하여 주시기 바랍니다.
                    </span>
                  </li>
                  <li class="small color">
                    <span class="ol_li_txt">
                      시험정보(모범답안, 채점기준 등)은 비공개 사항임을 반드시
                      확인하시기 바랍니다.
                    </span>
                  </li>
                  <li class="small color">
                    <span class="ol_li_txt">
                      협회는 첨단 전자기기 등에 의한 자격시험 부정행위에 예방을
                      강화하고 있으며, 부정한 방법으로 시험을 치룬 자는 응시자격
                      정지(3년), 시험무효 및 합격취소, 경찰 수사의뢰 등 강력조치
                      할 계획이오니 민간자격 시험 공신력 확보를 위해 적극 협조해
                      주시기 바랍니다.
                    </span>
                  </li>
                  <li class="small color">
                    <span class="ol_li_txt">
                      시험원서 접수 후에는 시험일정 등 변경이 불가하므로 접수 시
                      확인하여 착오 없으시기 바랍니다. (변경 필요 시에는 본
                      협회로 연락주시기 바랍니다.)
                    </span>
                  </li>
                  <li class="small color">
                    <span class="ol_li_txt">
                      답안지 작성은 반드시 컴퓨터용 사인펜만 사용하여야 합니다.
                      (그 외 연필류, 유색 필기구 등을 사용한 답항은 채점하지
                      않으며 0점 처리됩니다.)
                    </span>
                  </li>
                </ol>
              </div>
            </div>
          </div>
          <div class="modal_btn">
            <div class="btn_wrap">
              <button class="btn" @click="$emit('eventClose')">확인</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'modal-exam-info-popup',
  props: {
    data: {
      type: [Array, Object],
      default: () => {}
    },
    callBack: {
      type: [Function]
    }
  }
}
</script>

<style scoped></style>
